export const PHONE_DISPLAY = "0745 419 700";
export const PHONE_TEL = "tel:+40745419700";
export const WA_NUMBER = "40745419700";
export const WA_DEFAULT_TEXT =
  "Bună ziua! Doresc o ofertă pentru mobilier la comandă.";

export const waLink = (text = WA_DEFAULT_TEXT) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const toWaPhone = (phone) => {
  const digits = (phone || "").replace(/\D/g, "");
  if (digits.startsWith("0")) return `4${digits}`;
  return digits;
};

export const PROJECT_TYPES = [
  "Bucătărie la comandă",
  "Dressing / Dormitor / Dulap",
  "Uși interior / Scară din lemn",
  "Masă masivă / Mobilier living",
  "Tâmplărie specială / Proiect unicat",
  "Altceva",
];
